import { render, staticRenderFns } from "./promoCard.vue?vue&type=template&id=5667bdf6&scoped=true&"
import script from "./promoCard.vue?vue&type=script&lang=js&"
export * from "./promoCard.vue?vue&type=script&lang=js&"
import style0 from "./promoCard.vue?vue&type=style&index=0&id=5667bdf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5667bdf6",
  null
  
)

export default component.exports